export const BEGIN_LOGIN = 'BEGIN_LOGIN'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_EMAIL_INFO = 'SET_USER_EMAIL_INFO'
export const SET_CERTIFICATE_INFO = 'SET_CERTIFICATE_INFO'
export const END_LOGIN = 'END_LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'

export const SET_ALIPAY_FORM = 'SET_ALIPAY_FORM'

export const SET_MENU = 'SET_MENU'
export const SET_SERVICE_FOOTPRINT = 'SET_SERVICE_FOOTPRINT'
export const SET_PRE_MENU = 'SET_PRE_MENU'
export const SET_GIFTPACKAGE_STATUS = 'SET_GIFTPACKAGE_STATUS'
export const SET_BALANCE = 'SET_BALANCE'

export const SET_UNREAD_MSG = 'SET_UNREAD_MSG'
export const SET_MSG_DETAIL = 'SET_MSG_DETAIL'

export const SET_APPID = 'SET_APPID'
export const SET_APPNAME = 'SET_APPNAME'
export const SET_HISTORY_SERVICES = 'SET_HISTORY_SERVICES'

export const SET_LEVEL = 'SET_LEVEL'
export const SET_WEIXIN_INFO = 'SET_WEIXIN_INFO'



// WEBPACK FOOTER //
// ./app/store/mutation-types.js